var _filter, _filter2, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11DataChannel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "channelGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerDcA",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerDcB",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#047857"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowDc",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.25
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glowChannel",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 450,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    WebRTC Data Channels\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Send arbitrary data peer-to-peer\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 230)",
    filter: "url(#shadowDc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 200,
    height: 200,
    rx: 20,
    fill: "url(#peerDcA)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -65,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "Browser A"), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: -45,
    width: 170,
    height: 120,
    rx: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: -20,
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 9
  }, "const channel ="), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: -5,
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "  pc.createDataChannel("), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 10,
    fill: "#a78bfa",
    fontFamily: "monospace",
    fontSize: 9
  }, "    \"chatRoom\""), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 25,
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "  );"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 50,
    fill: "#94a3b8",
    fontFamily: "monospace",
    fontSize: 9
  }, "channel.send(\"Hello!\");"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(770, 230)",
    filter: "url(#shadowDc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 200,
    height: 200,
    rx: 20,
    fill: "url(#peerDcB)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -65,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "Browser B"), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: -45,
    width: 170,
    height: 120,
    rx: 8,
    fill: "#064e3b"
  }), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: -20,
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 9
  }, "pc.ondatachannel ="), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: -5,
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 9
  }, "  (event) => {"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 10,
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 9
  }, "    const ch = event.channel;"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 25,
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 9
  }, "    ch.onmessage = (e) =>"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 40,
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 9
  }, "      console.log(e.data);"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 55,
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 9
  }, "  };"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -180,
    y: -25,
    width: 360,
    height: 50,
    rx: 25,
    fill: "url(#channelGrad)",
    filter: "url(#glowChannel)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "\n      \uD83D\uDCE1 Data Channel: \"chatRoom\"\n    "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -12,
    width: 70,
    height: 24,
    rx: 12,
    fill: "#fbbf24"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    path: "M 270 230 L 630 230"
  })), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#1c1917",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    path: "M 270 230 L 630 230"
  }), "\n        \"Hello!\"\n      ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -12,
    width: 70,
    height: 24,
    rx: 12,
    fill: "#34d399"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s",
    path: "M 630 250 L 270 250"
  })), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#1c1917",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s",
    path: "M 630 250 L 270 250"
  }), "\n        \"Hi back!\"\n      ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -12,
    width: 50,
    height: 24,
    rx: 12,
    fill: "#06b6d4"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 270 270 L 630 270"
  })), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 270 270 L 630 270"
  }), "\n        \uD83D\uDCC1\n      ")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -300,
    y: -30,
    width: 600,
    height: 60,
    rx: 12,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    y: -5,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Data Channel Use Cases:"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -12,
    width: 80,
    height: 24,
    rx: 6,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\uD83D\uDCAC Chat")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -12,
    width: 100,
    height: 24,
    rx: 6,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\uD83D\uDCC1 File Transfer")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -12,
    width: 80,
    height: 24,
    rx: 6,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\uD83C\uDFAE Gaming")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -12,
    width: 100,
    height: 24,
    rx: 6,
    fill: "#c026d3"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "\uD83D\uDD04 State Sync")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 240 200 L 270 180",
    stroke: "#93c5fd",
    strokeWidth: 2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 660 200 L 630 180",
    stroke: "#6ee7b7",
    strokeWidth: 2,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11DataChannel);
export default __webpack_public_path__ + "static/media/11-data-channel.da21eb2fd33cfc635c24cd2aeed3a8fd.svg";
export { ForwardRef as ReactComponent };